import styled from "styled-components";

import { ButtonLabel } from "@similarweb/ui-components";

export const StyledSignalsList = styled.ul`
    margin: 0;
    padding: 0 24px;
`;

export const StyledSignalIntentWrapper = styled.li`
    padding: 20px 0 24px;
    border-bottom: 1px solid #dedede;

    &:last-child {
        border: none;
    }
`;

export const StyledSignalsNoData = styled.div`
    margin: 0;
    padding: 24px 30px;
`;

export const StyledSignalsManagementButton = styled.div`
    margin-top: 14px;
`;

export const StyledSignalsListShowMoreLabel = styled(ButtonLabel)`
    font-size: 18px;
`;

export const StyledSignalsListShowMoreLayout = styled.div`
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    box-sizing: border-box;
    width: 100%;
    height: 118px;
    padding-bottom: 16px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.13) 0%, #ffffff 100%);
    border-radius: 16px;

    ${StyledSignalsListShowMoreLabel} {
        font-weight: 700;
    }
`;
